<template>
  <div>
    <common-header :title="title" :is-back-btn="true" :back-fn="closeFn" :is-close-btn="false"
                     :go-to-schedule-fn="goToSchedule" :go-to-reserve-watch-fn="goToReserveWatch"></common-header>
    <div style="position:relative;">
      <component :is="componentName" :multi-section-list="multiSectionList" :key="multiSectionList.length"></component>
    </div>
  </div>
</template>

<script>
import BandRouterView from '@/views/supermultisection/BandRouterView'
import CommonHeader from '@/components/header/template/commonHeader'
import { PATH_NAME_RESERVE_WATCH, PATH_NAME_SCHEDULE } from '@/common/router.const'
export default {
  name: 'SuperMultiSectionList',
  components: { CommonHeader, BandRouterView },
  props: {
    multiSectionList: {
      type: Array
    },
    title: {
      type: String
    },
    componentName: {
      type: String
    },
    closeFn: {
      type: Function
    }
  },
  methods: {
    goToSchedule () {
      this.$router.push({ name: PATH_NAME_SCHEDULE })
    },
    goToReserveWatch () {
      this.$router.push({ name: PATH_NAME_RESERVE_WATCH })
    }
  }
}
</script>
<style lang="css" scoped>
  .band-view-header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
  }
  .band-view-view {
    height: 100vh;
    padding-top: 80px;
  }
  .band-view-view.not-mobile {
    padding-top: 0;
  }
  .band-view-view.not-mobile,
  .band-view-view-oksusu.not-mobile{
    padding-top: 0;
  }
  .band-view-view-oksusu {
    padding-top: 40px;
  }
</style>
